export const HOME_PAGE = "/";
export const OUR_SERVICES_PAGE = "/services";
export const BECOME_A_PARTNER  = "/become-a-partner";
export const CONTACT_PAGE ='/contact';
export const BIKE_SHARING='/bike-sharing';
export const SCOOTER_SHARING='/scooter-sharing';
export const POWER_BANK_SHARING='/power-bank-sharing';
